export default {
  EAT_SPINNER: 'spinner',
  EAT_CELL: 'clover and bomb'
}
